import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import ProfileAllPhotosModal from "./ProfileAllPhotosModal";
import { AnimatePresence } from "framer-motion";
import ImageSlider from "./image-slider";
import { useLocation, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { utils } from "../../Helpers/utils";
import InnerRatePanelBox from "./InnerRatePanelBox";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ModalHowItWorks from "./ModalHowItWorks";
import { GalleryVideo, InfluencerRating } from "../../Components";
import AddListandInfluencerToList from "../SearchInf/AddListandInfluencerToList";
import { searchProfileService, influencerlistService } from "../../Services";
import FollowerStats from "../../Components/Base/Charts/FollowerStats";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";
import {
  Toast,
  ModalAddInfToList,
  ModalConfirmDeleteInfluencer,
  removeProfile,
} from "../../Components";
import { storageHandler } from "../../Helpers";
import {
  Modal,
  AddOffer,
  showAllPhoto,
  tiktokFollowers,
  youtubeFollowers,
  fbFollowers,
  instaFollowers,
  saveProfile,
} from "../../Components";
import { InfluencerTamaScore } from "../../Components/InfluencerTamaScore";
import { InfluencerBrandSafety } from "../../Components/InfluencerBrandSafety";
import { InfluencerData } from "../../Components/InfluencerData";
import { InfluencerAdvancedInsights } from "../../Components/InfluencerAdvancedInsights";
import { InfluencerEngagement } from "../../Components/InfluencerEngagement";
import { InfluencerBrandsInterest } from "../../Components/InfluencerBrandsInterest";
import { InfluencerAudienceData } from "../../Components/InfluencerAudienceData";
import { InfluencerPost } from "../../Components/InfluencerPost";
import { hasPermission } from "../../Components/Constants/AppConstant";
import ModalNotSubscribe from "../../Components/Base/Common/Modal/ModalNotSubscribe";
import Lottie from "lottie-react";
import Progress from "../../../src/assets/Svgs/animationJson/Progress.json";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

// Error Boundary Component
// class ErrorBoundary extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = { hasError: false, error: null, errorInfo: null };
//   }

//   static getDerivedStateFromError(error) {
//     return { hasError: true };
//   }

//   componentDidCatch(error, errorInfo) {
//     this.setState({
//       error: error,
//       errorInfo: errorInfo,
//     });
//     console.error("Error caught by boundary:", error, errorInfo);
//   }

//   render() {
//     if (this.state.hasError) {
//       return (
//         <div
//           className="error-fallback"
//           style={{
//             padding: "20px",
//             textAlign: "center",
//             color: "#721c24",
//             backgroundColor: "#f8d7da",
//           }}
//         >
//           <h3>Something went wrong displaying this section.</h3>
//           <button
//             onClick={() =>
//               this.setState({ hasError: false, error: null, errorInfo: null })
//             }
//             style={{
//               padding: "8px 16px",
//               marginTop: "10px",
//               cursor: "pointer",
//             }}
//           >
//             Try Again
//           </button>
//         </div>
//       );
//     }

//     return this.props.children;
//   }
// }

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 4 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function InfluencerProfile({
  goToPricing,
  updateProfilePage,
  userTypeRegOrNon,
  setCloseCartFirsttime,
  setShowCart,
  setCartItem,
  cartItem,
  closeCartPanel,
  setAuth,
  user,
  NotifModul,
  profiles,
  setModalNotification,
}) {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const [value, setValue] = React.useState(0);
  const [influencerProfile, setInfluencerProfile] = useState();
  const [showActionIcon, setShowActionIcon] = useState(false);
  const [error, setError] = useState(null);
  const [isLoadedInfluencer, setIsLoadedInfluencer] = useState(false);
  const [fcbkModul, setFcbkModul] = useState([]);
  const [instModul, setInstModul] = useState([]);
  const [tiktokModul, setTiktokModul] = useState([]);
  const [youtubeModul, setyoutubeModul] = useState([]);
  const [selectedInfluencer, setSelectedInfluencer] = useState({});
  const [allInfluencerImage, setAllInfluencerImage] = useState([]);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  let pathSegments = location.pathname.split("/");
  const lastElement = pathSegments[pathSegments.length - 1];
  let userType = JSON.parse(storageHandler.getUserTypeForProfileItem());
  const [influencer, setInfluencer] = useState(lastElement);
  const [influencerUserType, setInfluencerUserType] = useState(userType);
  const [influencerFound, setInfluencerFound] = useState(false);
  const [toastList, setToastList] = useState([]);
  const [modal, setModal] = useState(null);
  const [saveToggle, setSaveToggle] = useState(false);
  const [tabIndex, setTabIndex] = useState();
  const [istabIndex, setIsTabIndex] = useState(false);
  const [isUserHasSubscription, setUserHasSubscription] = useState(false);
  const [pieChartData, setPieChartData] = useState(null);
  const [selectedCard, setSelectedCard] = useState("packages");
  const [userDatas, setUserDatas] = useState();
  const [isSubscribeModal, setIsSubscribeModal] = useState(false);
  const [isProgressModal, setIsProgressModal] = useState(false);
  const [isReadOnlyOffer, setIsReadOnlyOffer] = useState(false);
  const [selectedOfferData, setSelectedOfferData] = useState(null);
  const [infSocialType, setInfSocialType] = useState({
    IG: false,
    FB: false,
    TT: false,
    YT: false,
  });

  const showallphotosModal = () => {
    try {
      setShowCart(false);
      setModal("showallphotos");
    } catch (err) {
      console.error("Photo modal error:", err);
    }
  };

  const addToast = (data) => {
    try {
      const newToastList = [...toastList];
      newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
      setToastList(newToastList);
    } catch (err) {
      console.error("Toast error:", err);
    }
  };

  const handleSearch = () => {
    try {
      setModal(null);
      setSaveToggle(!saveToggle);
    } catch (err) {
      setError("Failed to update search");
      console.error("Search error:", err);
    }
  };

  const addCustomOffer = () => {
    try {
      setModal("addOffer");
    } catch (err) {
      setError("Failed to open custom offer");
      console.error("Custom offer error:", err);
    }
  };

  useEffect(() => {
    try {
      setInfluencer(lastElement);
      setInfluencerUserType(userType);
    } catch (err) {
      setError("Failed to set influencer data");
      console.error("Influencer data error:", err);
    }
    // eslint-disable-next-line 
  }, [updateProfilePage]);

  useEffect(() => {
    try {
      setUserHasSubscription(
        user !== null
          ? user.data.isUserHasSubscription === 1
            ? true
            : false
          : false
      );
    } catch (err) {
      setError("Failed to check subscription status");
      console.error("Subscription error:", err);
    }
  }, [user]);

  useEffect(() => {
    async function getInfluencerProfileDetail() {
      try {
        setIsLoadedInfluencer(false);
        setError(null);
        const res = await searchProfileService.searchInfluencerProfile(
          influencer,
          influencerUserType
        );
        if (res.success === true) {
          if (res.data) {
            setInfluencerProfile(res?.data);
            // Update infSocialType based on available data
            setInfSocialType({
              IG: res?.data?.IG?.length > 0,
              FB: res?.data?.FB?.length > 0,
              TT: res?.data?.TT?.length > 0,
              YT: res?.data?.YT?.length > 0,
            });
            let userImg = res?.data?.gallery_media;
            let lengthofImg = 0;
            if (userImg.length < 3) {
              lengthofImg = 3 - userImg.length;
            }
            if (userImg.length < 3) {
              for (let i = 0; i < lengthofImg; i++) {
                userImg.push({
                  image: "",
                  meta_1: "",
                  meta_2: "",
                  media_type_id: 2,
                });
              }
              setAllInfluencerImage(userImg);
              setIsImageLoaded(true);
            } else {
              setAllInfluencerImage(userImg);
              setIsImageLoaded(true);
            }
            let index = 0;
            let tabIndex = [];
            let Insta = res?.data?.product_rates?.filter(
              (item) => item?.platform === "IG"
            );
            let FB = res?.data?.product_rates?.filter(
              (item) => item?.platform === "FB"
            );
            let TT = res?.data?.product_rates?.filter(
              (item) => item?.platform === "TT"
            );
            let YT = res?.data?.product_rates?.filter(
              (item) => item?.platform === "YT"
            );

            if (Insta.length > 0) {
              index = index + 1;
              tabIndex["instModul"] = index;
            }
            if (TT.length > 0) {
              index = index + 1;
              tabIndex["tiktokModul"] = index;
            }
            if (YT.length > 0) {
              index = index + 1;
              tabIndex["youtubeModul"] = index;
            }
            if (FB.length > 0) {
              index = index + 1;
              tabIndex["fcbkModul"] = index;
            }
            setTabIndex(tabIndex);
            setIsTabIndex(true);
            setInstModul(Insta);
            setFcbkModul(FB);
            setTiktokModul(TT);
            setyoutubeModul(YT);
            setInfluencerFound(true);
          } else {
            setInfluencerFound(false);
          }
          setIsLoadedInfluencer(true);
        }
      } catch (err) {
        setIsLoadedInfluencer(true);
        setError("Failed to load influencer profile");
        addToast({
          error: true,
          msg: "Failed to load influencer profile",
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }

    async function getPieChart() {
      try {
        const pieChartData = await searchProfileService.getPieChartData(
          influencer,
          influencerUserType
        );
        if (pieChartData?.success) {
          setPieChartData(pieChartData.data[0]);
        }
      } catch (err) {
        console.error("Error fetching pie chart data:", err);
      }
    }
    getPieChart();
    getInfluencerProfileDetail();
    // eslint-disable-next-line 
  }, [saveToggle, influencer, updateProfilePage]);

  useEffect(() => {
    getInfluencerProfileDetail();
    // eslint-disable-next-line 
  }, [influencerProfile]);

  async function getInfluencerProfileDetail() {
    if (influencerProfile?.IG[0]?.id) {
      try {
        const userData = await searchProfileService.getIGInsights(
          influencerProfile?.IG[0]?.id,
          influencerProfile?.type
        );
        try {
          if (userData?.success) {
            setUserDatas(userData?.data);
          }
          console.log(
            "🚀 ~ getInfluencerProfileDetail ~ userData?.data:",
            userData?.data
          );
        } catch (err) {
          console.error("Error fetching user data:", err);
        }
      } catch (err) {
        console.error("Error fetching profile data:", err);
      }
    }
  }

  const encryptData = (data, secretKey) => {
    try {
      return CryptoJS.AES.encrypt(data, secretKey).toString();
    } catch (err) {
      console.error("Encryption error:", err);
      return data;
    }
  };

  const decryptData = (cipherText, secretKey) => {
    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (err) {
      console.error("Decryption error:", err);
      return cipherText;
    }
  };

  async function addToCart(module, product, influencerAccountCount) {
    let newObject = {
      platform_user_id: product.pt_user_id,
      influencerAccountCount: influencerAccountCount,
      followers_count: product.followers.toString(),
      description:
        product.name +
        " " +
        (product.description ? product.description : "") +
        (influencerAccountCount > 1
          ? "- Followerscount -" + module.followers_count
          : ""),
      quantity: 1,
      profileName: influencerProfile?.display_name,
      profileImage: influencerProfile?.profile_img_url,
      price: product.rate,
      product: product.name,
      product_id: product.product_id,
      to_user_id: influencerProfile?.id,
      to_user_type: influencerUserType,
      cart_item_addedBy: user.data.id,
      offer_type: "product",
    };

    setCartItem(
      // Replace the state
      [
        // with a new array
        ...cartItem, // that contains all the old items
        newObject, // and one new item at the end
      ]
    );
    let encrypteddata = encryptData(
      JSON.stringify([
        // with a new array
        ...cartItem, // that contains all the old items
        newObject, // and one new item at the end
      ]),
      secretKey
    );
    //const encryptedText = encryptData("Hello, World!", secretKey);
    //setCartItem(prevArray => [...prevArray, newObject]);
    storageHandler.setCartItem(encrypteddata);
    setShowCart(true);
    //cartItemNew.push()
    // setCartItem(cartItem);
    //setCartItem(prevArray => [...prevArray, newObject]);

    //storageHandler.setCartItem(JSON.stringify(cartItem));
    /*try {
      const payload = { 'productid': id, 'rate': price, ''}
      const res = await offerService.createOffer();
      console.log(res);
  
    } catch (err) {
      setError("Failed to add item to cart");
      console.error("Add to cart error:", err);
      addToast({
        error: true,
        msg: "Failed to add item to cart",
        id: `${Date.now()}-${toastList.length}`,
      });
    }*/
  }

  const chkLoginandActionAccordingly = (event, influencer) => {
    try {
      if (profiles !== undefined) {
        setSelectedInfluencer(influencer);
        setModal("addtoList");
      } else {
        navigate("/account/pricing");
      }
    } catch (err) {
      setError("Failed to process action");
      console.error("Action error:", err);
    }
  };

  const confirmRemoveFromList = async (event, influencer) => {
    try {
      event.stopPropagation();
      setSelectedInfluencer(influencer);
      setModal("confirmDelete");
    } catch (err) {
      setError("Failed to remove from list");
      console.error("Remove from list error:", err);
    }
  };

  useEffect(() => {
    try {
      let decryptedData = storageHandler.getCartItem();
      if (decryptedData !== null) {
        const storedCartItem = decryptData(decryptedData, secretKey);
        setCartItem(storedCartItem.length > 0 && JSON.parse(storedCartItem));
      }
      setCloseCartFirsttime(false);
    } catch (err) {
      console.error("Cart initialization error:", err);
    }
    // eslint-disable-next-line 
  }, [influencer, updateProfilePage]);

  const removeFromList = async (influencer) => {
    try {
      let option = {
        inf_user_id: influencer.id,
        inf_user_type: influencer.type,
      };
      const res = await influencerlistService.removeFromList(
        influencer.list_id,
        option
      );
      addToast({
        error: false,
        msg: res.message,
        id: `${Date.now()}-${toastList.length}`,
      });
      handleSearch();
    } catch (err) {
      setError("Failed to remove from list");
      console.error("Remove from list error:", err);
      addToast({
        error: true,
        msg: err,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };

  useEffect(() => {
    try {
      setShowCart(false);
    } catch (err) {
      console.error("Cart visibility error:", err);
    }
    // eslint-disable-next-line 
  }, []);

  let data = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      data = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }

  const handlePricingAnalytics = () => {
    if (infSocialType?.IG) {
      if (userDatas?.profile?.length === 0) {
        setSelectedCard("analytics");
        setIsProgressModal(true)
        // setTimeout(() => setIsProgressModal(true), 10);
      } else if (hasPermission(11)) {
        setSelectedCard("analytics");
      } else {
        setIsSubscribeModal(true);
      }
    }
  };

  return (
    <>
      <div className="main">
        {/* <div className="main__inner"> */}
        <div className="profile-container">
          {isImageLoaded &&
            isLoadedInfluencer &&
            influencerFound === true &&
            istabIndex && (
              <div className="share-save">
                <div className="top-icons">
                  <div className="social-icons">
                    {influencerProfile?.list_id === null ? (
                      <button
                        className="search-btn"
                        onClick={(e) =>
                          chkLoginandActionAccordingly(e, influencerProfile)
                        }
                      >
                        {saveProfile}
                        Save
                      </button>
                    ) : (
                      <button
                        className="search-btn"
                        onClick={(e) =>
                          confirmRemoveFromList(e, influencerProfile)
                        }
                      >
                        {removeProfile}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          {isImageLoaded && (
            <>
              <div className="relative mb-8">
                <div className="!grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 !gap-4">
                  {allInfluencerImage?.slice(0, 3).map((item, index) => {
                    return (
                      <div key={index} className="aspect-square rounded-2xl overflow-hidden border border-gray-100 shadow-sm bg-gray-50">
                        {item.media_type_id === 2 ? (
                          <div
                            className="w-full h-full bg-cover bg-center transition-transform duration-500 hover:scale-110"
                            style={{
                              backgroundImage:
                                item.media_url === ""
                                  ? `url( ${process.env.PUBLIC_URL}/images/placeholder/list_image.jpg)`
                                  : `url(${encodeURI(item.media_url)})`,
                            }}
                          ></div>
                        ) : (
                          item.media_type_id === 1 && (
                            <GalleryVideo
                              setShowActionIcon={setShowActionIcon}
                              key={item.id || index}
                              media_url={item.media_url}
                              status={"visible"}
                              media_type_id={item.media_type_id}
                            />
                          )
                        )}
                      </div>
                    );
                  })}
                </div>

                {allInfluencerImage.length > 3 && (
                  <button
                    id="showallphotosbutton"
                    className="absolute bottom-4 right-4 flex items-center gap-2 px-5 py-2.5 bg-white/90 backdrop-blur-sm text-gray-800 text-sm font-bold rounded-2xl shadow-xl hover:bg-white hover:scale-105 transition-all duration-200 border border-gray-200 z-10"
                    onClick={showallphotosModal}
                  >
                    <span className="flex items-center gap-2">
                      {showAllPhoto}
                      <span>Show All Photos</span>
                    </span>
                  </button>
                )}
              </div>

              <div className="slider">
                <ImageSlider
                  setShowActionIcon={setShowActionIcon}
                  allInfluencerImage={allInfluencerImage}
                  influencerProfile={influencerProfile}
                />
              </div>
            </>
          )}
          {isLoadedInfluencer && istabIndex && (
            <>
              <div className="flex flex-col md:flex-row gap-8 px-4">
                <div className="flex-1">
                  <div className="flex items-center mb-5">
                    <img
                      alt="Influencer"
                      className="rounded-full w-20 h-20 mr-4 flex-shrink-0"
                      src={
                        influencerProfile?.profile_img_url?.trim()
                          ? influencerProfile?.profile_img_url
                          : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                      }
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                      }}
                    />
                    <div>
                      <h1 className="text-2xl m-0 text-gray-800 font-bold text-left leading-8">
                        {influencerProfile?.display_name} |{" "}
                        {influencerProfile?.categories
                          ?.slice(0, 2)
                          .map((obj) => obj.name)
                          .join(", ")}
                      </h1>
                      <p className="m-0 text-gray-600 text-left mb-2.5">
                        {influencerProfile?.country}
                      </p>
                      <div className="ml-auto flex items-center flex-wrap gap-2.5">
                        {influencerProfile?.IG?.length > 0 &&
                          influencerProfile?.IG.map((igfollowers, i) => (
                            <span
                              key={`ig-${i}`}
                              className="flex items-center px-2 py-2 border border-gray-500 rounded-lg shadow-sm bg-white font-bold text-gray-900 gap-1"
                            >
                              <span className="">{instaFollowers}</span>
                              <span>
                                {utils.convertNumber(igfollowers.followers)}{" "}
                                Followers
                              </span>
                            </span>
                          ))}
                        {influencerProfile?.FB?.length > 0 &&
                          influencerProfile?.FB.map((fbfollowers, i) => (
                            <span
                              key={`fb-${i}`}
                              className="flex items-center px-2 py-2 border border-gray-500 rounded-lg shadow-sm bg-white font-bold text-gray-900 gap-1"
                            >
                              <span className="">{fbFollowers}</span>
                              <span>
                                {utils.convertNumber(fbfollowers.followers)}{" "}
                                Followers
                              </span>
                            </span>
                          ))}
                        {influencerProfile?.TT?.length > 0 &&
                          influencerProfile?.TT.map((ttfollowers, i) => (
                            <span
                              key={`tt-${i}`}
                              className="flex items-center px-2 py-2 border border-gray-500 rounded-lg shadow-sm bg-white font-bold text-gray-900 gap-1"
                            >
                              <span className="">{tiktokFollowers}</span>
                              <span>
                                {utils.convertNumber(ttfollowers.followers)}{" "}
                                Followers
                              </span>
                            </span>
                          ))}
                        {influencerProfile?.YT?.length > 0 &&
                          influencerProfile?.YT.map((ytfollowers, i) => (
                            <span
                              key={`yt-${i}`}
                              className="flex items-center px-2 py-2 border border-gray-500 rounded-lg shadow-sm bg-white font-bold text-gray-900 gap-1"
                            >
                              <span className="">{youtubeFollowers}</span>
                              <span>
                                {utils.convertNumber(ytfollowers.followers)}{" "}
                                Followers
                              </span>
                            </span>
                          ))}
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between w-full items-center my-8">
                    {influencerProfile && (
                      <div
                        className="flex gap-1 justify-center"
                        data-rating="0"
                      >
                        <InfluencerRating
                          infrating={influencerProfile?.rating}
                        />
                      </div>
                    )}
                  </div>

                  <div className="text-sm text-gray-800">
                    <p className="flex justify-between w-full">
                      {influencerProfile
                        ? utils.testJSON(influencerProfile?.bio)
                          ? utils.draftJsFormatingForDetailsBio({
                              data: influencerProfile?.bio,
                              view: "fullview",
                            })
                          : influencerProfile?.bio
                        : "NA"}
                    </p>
                  </div>
                </div>

                <div className="flex-1 flex flex-col justify-end relative mt-8 md:mt-0">
                  {/* <div className="md:absolute md:top-0 md:right-0 mb-4 md:mb-0">
                        <div className="relative inline-block">
                          <button className="px-4 py-2 bg-white border text-black rounded-full text-sm font-medium shadow-sm flex items-center gap-1">
                            Analytics
                          </button>
                          <span className="absolute -top-2 -right-2 text-white text-[10px] font-semibold px-2 py-[2px] rounded-full bg-[linear-gradient(90deg,_rgb(94,176,90)_0%,_rgb(54,122,64)_50%,_rgb(16,38,32)_100%)] shadow">
                            Coming Soon
                          </span>
                        </div>
                      </div> */}

                  <div className="my-auto">
                    <FollowerStats data={pieChartData} />
                  </div>
                </div>
              </div>

              <div className="packages relative">
                <div className="flex flex-col gap-4 lg:flex-row justify-left mb-6 border-b border-gray-300 relative">
                  {/* Packages Card */}
                  <div
                    className={`relative border rounded-xl rounded-b-none p-2 w-full max-w-xs cursor-pointer transition-colors bg-white ${
                      selectedCard === "packages"
                        ? "border-green-500 border-b-0 text-green-500"
                        : "border-gray-200"
                    }`}
                    onClick={() => setSelectedCard("packages")}
                  >
                    {/* Mask to hide parent's bottom border */}
                    {selectedCard === "packages" && (
                      <div className="absolute bottom-[-1px] left-0 w-full h-[1px] bg-white"></div>
                    )}

                    <div className="flex flex-col items-center text-center">
                      <span className="font-bold text-lg md:text-xl">
                        Packages
                      </span>
                      <button
                        type="button"
                        style={{
                          backgroundColor: "transparent",
                          height: "fit-content",
                        }}
                        className={`text-xs p-0 m-0 border-none w-fit ${
                          selectedCard === "packages"
                            ? "text-green-500"
                            : "text-gray-600"
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowCart(false);
                          setModal("howitworks");
                        }}
                      >
                        How does it work?
                      </button>
                    </div>
                  </div>

                  {/* Analytics Card */}
                  <div
                    className={`relative border rounded-xl rounded-b-none p-4 w-full max-w-xs cursor-pointer transition-colors bg-white ${
                      selectedCard === "analytics"
                        ? "border-green-500 border-b-0 text-green-500"
                        : "border-gray-200"
                    }`}
                    onClick={() => handlePricingAnalytics()}
                  >
                    {/* Mask to hide parent's bottom border */}
                    {selectedCard === "analytics" && (
                      <div className="absolute bottom-[-1px] left-0 w-full h-[1px] bg-white"></div>
                    )}

                    <div className="flex flex-col items-center text-center">
                      <span className="font-bold text-lg md:text-xl">
                        Analytics
                      </span>
                    </div>
                    {!infSocialType?.IG && (
                      <span className="absolute -top-3 right-0 bg-gradient-to-r from-green-500 to-black text-white text-xs font-semibold px-3 py-1 rounded-full shadow-lg">
                        Coming Soon
                      </span>
                    )}
                  </div>
                </div>

                <Box sx={{ width: "100%" }} className="tab-box mt-5">
                  <>
                    {selectedCard === "packages" ? (
                      <>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                          <Tabs value={value} aria-label="basic tabs example">
                            <Tab
                              label="All"
                              {...a11yProps(0)}
                              onClick={() => {
                                setValue(0);
                                setShowCart(false);
                              }}
                            />
                            {instModul.length > 0 && tabIndex && (
                              <Tab
                                onClick={() => {
                                  setValue(tabIndex["instModul"]);
                                  setShowCart(false);
                                }}
                                label="Instagram"
                                {...a11yProps(tabIndex["instModul"])}
                              />
                            )}

                            {tiktokModul.length > 0 && tabIndex && (
                              <Tab
                                onClick={() => {
                                  setValue(tabIndex["tiktokModul"]);
                                  setShowCart(false);
                                }}
                                label="Tiktok"
                                {...a11yProps(tabIndex["tiktokModul"])}
                              />
                            )}
                            {youtubeModul.length > 0 && tabIndex && (
                              <Tab
                                label="YouTube"
                                onClick={() => {
                                  setValue(tabIndex["youtubeModul"]);
                                  setShowCart(false);
                                }}
                                {...a11yProps(tabIndex["youtubeModul"])}
                              />
                            )}
                            {fcbkModul.length > 0 && tabIndex && (
                              <Tab
                                onClick={() => {
                                  setValue(tabIndex["fcbkModul"]);
                                  setShowCart(false);
                                }}
                                label="FaceBook"
                                {...a11yProps(tabIndex["fcbkModul"])}
                              />
                            )}
                          </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                          <div className="inner-packages">
                            <InnerRatePanelBox
                              influencerUserType={influencerUserType}
                              addToCart={addToCart}
                              package={"all"}
                              instModul={instModul}
                              tiktokModul={tiktokModul}
                              youtubeModul={youtubeModul}
                              fcbkModul={fcbkModul}
                              addCustomOffer={addCustomOffer}
                              setIsReadOnlyOffer={setIsReadOnlyOffer}
                              setSelectedOfferData={setSelectedOfferData}
                            />
                          </div>
                        </CustomTabPanel>
                        {instModul.length > 0 && (
                          <CustomTabPanel
                            value={value}
                            index={tabIndex["instModul"]}
                          >
                            <div className="inner-packages">
                              <InnerRatePanelBox
                                influencerUserType={influencerUserType}
                                addToCart={addToCart}
                                package={"insta"}
                                instModul={instModul}
                                addCustomOffer={addCustomOffer}
                                setIsReadOnlyOffer={setIsReadOnlyOffer}
                                setSelectedOfferData={setSelectedOfferData}
                              />
                            </div>
                          </CustomTabPanel>
                        )}

                        {tiktokModul.length > 0 && (
                          <CustomTabPanel
                            value={value}
                            index={tabIndex["tiktokModul"]}
                          >
                            <div className="inner-packages">
                              <InnerRatePanelBox
                                influencerUserType={influencerUserType}
                                addToCart={addToCart}
                                package={"tiktok"}
                                tiktokModul={tiktokModul}
                                addCustomOffer={addCustomOffer}
                                setIsReadOnlyOffer={setIsReadOnlyOffer}
                                setSelectedOfferData={setSelectedOfferData}
                              />
                            </div>
                          </CustomTabPanel>
                        )}
                        {youtubeModul.length > 0 && (
                          <CustomTabPanel
                            value={value}
                            index={tabIndex["youtubeModul"]}
                          >
                            <div className="inner-packages">
                              <InnerRatePanelBox
                                influencerUserType={influencerUserType}
                                addToCart={addToCart}
                                package={"youtube"}
                                youtubeModul={youtubeModul}
                                addCustomOffer={addCustomOffer}
                                setIsReadOnlyOffer={setIsReadOnlyOffer}
                                setSelectedOfferData={setSelectedOfferData}
                              />
                            </div>
                          </CustomTabPanel>
                        )}
                        {fcbkModul.length > 0 && (
                          <CustomTabPanel
                            value={value}
                            index={tabIndex["fcbkModul"]}
                          >
                            <div className="inner-packages">
                              <InnerRatePanelBox
                                influencerUserType={influencerUserType}
                                addToCart={addToCart}
                                package={"facebook"}
                                fcbkModul={fcbkModul}
                                addCustomOffer={addCustomOffer}
                                setIsReadOnlyOffer={setIsReadOnlyOffer}
                                setSelectedOfferData={setSelectedOfferData}
                              />
                            </div>
                          </CustomTabPanel>
                        )}

                        {(instModul?.length > 0 ||
                          fcbkModul?.length > 0 ||
                          youtubeModul?.length > 0 ||
                          tiktokModul?.length > 0) &&
                          influencerUserType !== "r" && (
                            <div className="bottom-row">
                              <div className="smallTextForAsterisk">
                                <span className="asterisk">*</span> Price for
                                all Products determined by AI
                              </div>
                            </div>
                          )}

                        <CustomTabPanel className="addCustomOffer">
                          <div className="inner-packages">
                            <div className="package">
                              <div className="bottom-row">
                                <div className="">
                                  Have a request not offered above?
                                </div>
                                <button
                                  className="add-to-cart"
                                  onClick={() => {
                                    addCustomOffer();
                                    setIsReadOnlyOffer(false);
                                    setSelectedOfferData(null);
                                  }}
                                >
                                  Add a Custom Offer
                                </button>
                              </div>
                            </div>
                          </div>
                        </CustomTabPanel>
                      </>
                    ) : (
                      <>
                        {isUserHasSubscription && data.p_f_ids.includes(11) && (
                          <>
                            {/* TAMA Score */}
                            <InfluencerTamaScore
                              userName={influencerProfile?.display_name}
                              userData={pieChartData}
                              totalFollowers={influencerProfile}
                              credibility={
                                userDatas?.audience_followers_summary?.[0]
                                  ?.audience_credibility
                              }
                              breakdown={userDatas?.audience_followers_types}
                              tamaScore={userDatas?.profile?.[0]?.tama_score}
                              tamaScoreText={
                                userDatas?.profile?.[0]?.tama_score_text
                              }
                              performanceScore={
                                userDatas?.profile?.[0]?.performance_score
                              }
                              performanceScoreText={
                                userDatas?.profile?.[0]?.performance_score_text
                              }
                            />

                            {/* Brand Safety */}
                            <InfluencerBrandSafety userDatas={userDatas} />

                            {/* Influencer data */}
                            <InfluencerData userDatas={userDatas} />

                            {/* Advanced Insights */}
                            <InfluencerAdvancedInsights userDatas={userDatas} />

                            {/* Engagement chart */}
                            <InfluencerEngagement userDatas={userDatas} />

                            {/* Brands and Interest */}
                            <InfluencerBrandsInterest userDatas={userDatas} />

                            {/* Audience Data */}
                            <InfluencerAudienceData userDatas={userDatas} />

                            {/* Influencer post */}
                            <InfluencerPost userDatas={userDatas} />
                          </>
                        )}
                        {isUserHasSubscription === false && user !== null && (
                          <>
                            <NotSubscribe
                              goToPricing={goToPricing}
                              type="brand"
                              setAuth={setAuth}
                              setModal={setModal}
                              NotifModul={NotifModul}
                              setNotifModul={setModalNotification}
                              profiles={profiles}
                              closeCartPanel={closeCartPanel}
                              user={user}
                              cartItem={cartItem}
                              title={"Analytics"}
                              background={"background_inflist.png"}
                            />
                          </>
                        )}
                      </>
                    )}
                  </>
                </Box>
              </div>
            </>
          )}
        </div>
        {isLoadedInfluencer && influencerFound === false && (
          <div className="profile-container">
            <div className="description">
              <h4> No Influencer found.</h4>
            </div>
          </div>
        )}
        <AnimatePresence>
          {modal === "showallphotos" && (
            <ProfileAllPhotosModal
              close={() => setModal(null)}
              galleryInfluencerImage={allInfluencerImage}
            />
          )}
          {modal === "addOffer" && (
            <Modal addClass="modalAsset" close={() => setModal(null)}>
              <div className="modal__asset">
                <div className="modal__asset-inner">
                  <AddOffer
                    user={user}
                    instModul={instModul}
                    fcbkModul={fcbkModul}
                    tiktokModul={tiktokModul}
                    youtubeModul={youtubeModul}
                    setModal={setModal}
                    setToastList={setToastList}
                    influencerProfile={influencerProfile}
                    toastList={toastList}
                    cartItem={cartItem}
                    setCartItem={setCartItem}
                    setShowCart={setShowCart}
                    influencerUserType={influencerUserType}
                    isReadOnlyOffer={isReadOnlyOffer}
                    selectedOfferData={selectedOfferData}
                  />
                </div>
              </div>
            </Modal>
          )}
          {modal === "addtoList" && (
            <ModalAddInfToList
              influencerUserType={influencerUserType}
              setToastList={setToastList}
              toastList={toastList}
              close={() => setModal(null)}
              setModal={setModal}
              selectedInfluencer={selectedInfluencer}
              handleSearch={handleSearch}
            />
          )}
          {modal === "addList" && (
            <Modal addClass="addInfToListModal" close={() => setModal(null)}>
              <div className="filterModal modal__camp">
                <AddListandInfluencerToList
                  handleSearch={handleSearch}
                  setToastList={setToastList}
                  toastList={toastList}
                  setTabModal={setModal}
                  selectedInfluencer={selectedInfluencer}
                />
              </div>
            </Modal>
          )}
          {modal === "howitworks" && (
            <ModalHowItWorks close={() => setModal(null)} />
          )}
          {modal === "confirmDelete" && (
            <ModalConfirmDeleteInfluencer
              removeFromList={removeFromList}
              setToastList={setToastList}
              toastList={toastList}
              close={() => setModal(null)}
              setModal={setModal}
              selectedInfluencer={selectedInfluencer}
            />
          )}
        </AnimatePresence>
        {toastList && <Toast list={toastList} setList={setToastList} />}
        {/* </div> */}
      </div>
      {isSubscribeModal && (
        <ModalNotSubscribe
          goToPricing={goToPricing}
          type="brand"
          // setAuth={setAuth}
          // setModal={setModal}
          // NotifModul={NotifModul}
          // setNotifModul={setModalNotification}
          // profiles={profiles}
          // closeCartPanel={closeCartPanel}
          // user={user}
          // cartItem={cartItem}
          title={"Direct Campaigns"}
          onClose={() => setIsSubscribeModal(false)}
          // background={"background_inflist.png"}
        />
      )}
      {isProgressModal && (
        <Modal
          close={() => {
            setIsProgressModal(false);
            setSelectedCard("packages");
          }}
          className="!mr-[90px]"
        >
          <div
            className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden !ml-[80px] "
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <div className="absolute -top-20 -left-20 w-40 h-40 bg-green-400/30 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-emerald-400/30 rounded-full blur-3xl"></div>

            <div className="relative px-8 pt-4 pb-4 text-center">
              <div className="flex justify-center mb-3">
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full blur-2xl opacity-30 animate-pulse"></div>
                  <Lottie
                    animationData={Progress}
                    style={{ height: "80px", width: "150px" }}
                  />
                </div>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Report Generation in Progress
              </h3>
              <p className="text-gray-600 leading-relaxed max-w-md mx-auto">
                We're analyzing your data and generating comprehensive insights.
                This usually takes a few moments.
              </p>
            </div>

            <div className="px-4 pb-4">
              <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 rounded-xl p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <svg
                      className="w-5 h-5 text-emerald-600 mt-0.5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-emerald-800">
                      <span className="font-semibold">Did you know?</span> You
                      can continue working while we generate your report. We'll
                      notify you when it's ready.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-8 py-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-b-3xl border-t border-gray-200">
              <div className="flex justify-end space-x-3">
                <button
                  className="px-6 py-3 text-sm font-semibold text-white bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl hover:from-green-600 hover:to-emerald-700 transition-all duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 shadow-lg hover:shadow-xl"
                  onClick={() => {
                    setIsProgressModal(false);
                    setSelectedCard("packages");
                  }}
                >
                  Got It
                </button>
              </div>
            </div>
          </div>

          <style jsx>{`
            @keyframes shimmer {
              0% {
                transform: translateX(-100%);
              }
              100% {
                transform: translateX(100%);
              }
            }
            .animate-shimmer {
              animation: shimmer 2s infinite;
            }
            @keyframes animate-in {
              from {
                opacity: 0;
                transform: scale(0.95) translateY(10px);
              }
              to {
                opacity: 1;
                transform: scale(1) translateY(0);
              }
            }
            .animate-in {
              animation: animate-in 0.3s ease-out;
            }
          `}</style>
        </Modal>
      )}
    </>
  );
}
